import {GROWL_TYPE, showMessageGrowl} from '@Components/message-growl';

const MAKE_TEXT_EDITABLE_GROWL_KEY = 'make-text-editable-conversion';

let conversionPending = false;
let handedOffToGrowl = false;

/**
 * Sticky "converting" growl shown after the user dismisses the mobile loading modal mid-pipeline.
 * Reuses the same key as the done/error growls so the toast updates in place.
 */
const showMakeTextEditableOngoingGrowl = (): void => {
  showMessageGrowl({
    key: MAKE_TEXT_EDITABLE_GROWL_KEY,
    type: GROWL_TYPE.NEUTRAL,
    text: window.i18next.t('pmwjs_mte_converting_layers'),
    isLoading: true,
    sticky: true,
    showCloseIcon: false,
  });
};

/**
 * Sticky "ready" growl with an inline "Edit design" link that opens the editor in the same tab (mobile).
 */
export const showMakeTextEditableDoneGrowl = (navigationUrl: string): void => {
  showMessageGrowl({
    key: MAKE_TEXT_EDITABLE_GROWL_KEY,
    type: GROWL_TYPE.NEUTRAL,
    text: window.i18next.t('pmwjs_mte_layers_ready_growl'),
    icon: 'icon-check-filled',
    iconClassName: 'content-success',
    sticky: true,
    showCloseIcon: false,
    action: {
      label: window.i18next.t('pmwjs_mte_edit_design'),
      url: navigationUrl,
      openInNewTab: false,
    },
  });
};

export const showMakeTextEditableErrorGrowl = (): void => {
  showMessageGrowl({
    key: MAKE_TEXT_EDITABLE_GROWL_KEY,
    type: GROWL_TYPE.DANGER,
    text: window.i18next.t('pmwjs_mte_conversion_failed'),
    showCloseIcon: true,
  });
};

export const setMakeTextEditableConversionPending = (pending: boolean): void => {
  conversionPending = pending;
  if (pending) {
    handedOffToGrowl = false;
  }
};

export const isMakeTextEditableConversionPending = (): boolean => {
  return conversionPending;
};

export const isMakeTextEditableHandedOffToGrowl = (): boolean => {
  return handedOffToGrowl;
};

export const handleMakeTextEditableModalDismissed = (): void => {
  handedOffToGrowl = true;
  showMakeTextEditableOngoingGrowl();
};
